module.exports = __webpack_public_path__ + "img/alfred.6b013b65.svg";